import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ZapIcon from '@zapsa/zap-icons';
import { NavLink } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';

import hostedInLuxembourg from 'assets/images/hosted_in_luxembourg.svg';

class PricingView extends Component {
  static propTypes = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div
        id="pricing"
        style={{
          width: '100vw',
          overflow: 'hidden',

          background: 'linear-gradient(180deg, #F6F6F6 40%, #FFFFFF 60%)',
        }}
      >
        <div className="container">
          <div className="container-title">{this.props.translations['pricing.ourHostingModels']}</div>
          <div className="pricings-container">
            <div className="box price-box">
              {/* <div data-tip data-for="data-tooltip-average">
                <ZapIcon icon="infoCircle--lines" className="extra-infos" />
              </div> */}
              <img src={hostedInLuxembourg} alt="" data-tip data-for="data-tooltip-hosting" />
              <ZapIcon icon="server--lines" />
              <div>{this.props.translations['pricing.private']}</div>
              <div className="price-details">
                <div />
                <div
                  role="presentation"
                  className="u-cursor"
                  onClick={() => {
                    window.fcWidget.open();
                    // this.props.history.push('/contact');
                  }}
                >
                  {this.props.translations['pricing.requestQuotation']}
                </div>
              </div>
              {/* <div className="price-details">
                <div data-tip data-for="data-tooltip-depractive">
                  8€
                </div>
                <div>{this.props.translations['pricing.perUserMonth']}</div>
              </div> */}
            </div>
            <div className="box price-box">
              {/* <div data-tip data-for="data-tooltip-average">
                <ZapIcon icon="infoCircle--lines" className="extra-infos" />
              </div> */}
              <img src={hostedInLuxembourg} alt="" data-tip data-for="data-tooltip-hosting" />
              <ZapIcon icon="server-network--lines" />
              <div>{this.props.translations['pricing.shared']}</div>
              <div className="price-details">
                <div />
                <div
                  role="presentation"
                  className="u-cursor"
                  onClick={() => {
                    window.fcWidget.open();
                    // this.props.history.push('/contact');
                  }}
                >
                  {this.props.translations['pricing.requestQuotation']}
                </div>
              </div>
              {/* <div className="price-details">
                <div data-tip data-for="data-tooltip-depractive">
                  6€
                </div>
                <div>{this.props.translations['pricing.perUserMonth']}</div>
              </div> */}
            </div>
            <div className="box price-box">
              <ZapIcon icon="server-share--lines" />
              <div>{this.props.translations['pricing.onPremise']}</div>
              <div className="price-details">
                <div />
                <div
                  role="presentation"
                  className="u-cursor"
                  onClick={() => {
                    window.fcWidget.open();
                    // this.props.history.push('/contact');
                  }}
                >
                  {this.props.translations['pricing.requestQuotation']}
                </div>
              </div>
            </div>
          </div>
          <div className="contact">
            <div
              onClick={() => {
                window.fcWidget.open();
              }}
              role="presentation"
              className="contact-button"
            >
              {this.props.translations['pricing.requestQuotation']}
            </div>
          </div>
          <div className="perks-details-container">
            <div>
              <div className="perk">
                <div className="u-flex u-flex-align-items">
                  <ZapIcon icon="circle-cash--lines" />
                </div>
                <div>{this.props.translations['pricing.depractive']}</div>
              </div>
              {/* <div className="perk u-mt-2">
                <div className="u-flex u-flex-align-items">
                  <ZapIcon icon="infoCircle--lines" className="extra-infos" />
                </div>
                <div>{this.props.translations['pricing.averagePrice']}</div>
              </div> */}
              <div className="perk u-mt-2" data-tip data-for="data-tooltip">
                <div className="u-flex u-flex-align-items">
                  <img src={hostedInLuxembourg} alt="" />
                </div>
                <div>{this.props.translations['pricing.hosting']()}</div>
              </div>
              <ReactTooltip
                className="tooltip"
                id="data-tooltip"
                type="info"
                effect="solid"
                delayShow={500}
                place="bottom"
              >
                {this.props.translations['pricing.storageLimit']()}
              </ReactTooltip>
              <ReactTooltip
                className="tooltip"
                id="data-tooltip-average"
                type="info"
                effect="solid"
                delayShow={500}
                place="bottom"
              >
                {this.props.translations['pricing.averagePrice']}
              </ReactTooltip>
              <ReactTooltip
                className="tooltip"
                id="data-tooltip-depractive"
                type="info"
                effect="solid"
                delayShow={500}
                place="bottom"
              >
                {this.props.translations['pricing.depractive']}
              </ReactTooltip>
              <ReactTooltip
                className="tooltip"
                id="data-tooltip-hosting"
                type="info"
                effect="solid"
                delayShow={500}
                place="bottom"
              >
                {this.props.translations['pricing.hosting']()}
              </ReactTooltip>
            </div>
          </div>
          <div className="download">
            <a
              href="https://static.squareboard.cloud/plaquette_squareboard.pdf"
              className="download-button"
              download
              target="_blank"
              rel="noopener noreferrer"
            >
              {this.props.translations['contact.downloadBrochure']}
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default PricingView;
